import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as authApi from '../api/auth';
import buttonStyles from '../components/Buttons.module.css';
import pawImg from '../assets/paw.png';

const ConfirmationError: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [lastSubmittedEmail, setLastSubmittedEmail] = useState('');

  const handleResend = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Prevent multiple submissions while loading
    if (loading) return;
    
    // Prevent resubmitting the same email
    const trimmedEmail = email.trim();
    if (trimmedEmail === lastSubmittedEmail) {
      return;
    }
    
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await authApi.resendConfirmation(trimmedEmail);
      setSuccess(true);
      setLastSubmittedEmail(trimmedEmail);
      setEmail('');
    } catch (err: any) {
      const message = err?.response?.data?.error || err?.message || 'Failed to resend confirmation email';
      setError(message);
      setLastSubmittedEmail(trimmedEmail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container cream-bg">
      <div className="hero-paw-bg">
        <img src={pawImg} className="hero-paw-float paw1" alt="" />
        <img src={pawImg} className="hero-paw-float paw2" alt="" />
        <img src={pawImg} className="hero-paw-float paw3" alt="" />
        <img src={pawImg} className="hero-paw-float paw4" alt="" />
        <img src={pawImg} className="hero-paw-float paw5" alt="" />
        <img src={pawImg} className="hero-paw-float paw6" alt="" />
        <img src={pawImg} className="hero-paw-float paw7" alt="" />
      </div>

      <div style={{ maxWidth: 560, margin: '0 auto', padding: '2rem' }}>
        <div className="page-intro" style={{ padding: 0 }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem', textAlign: 'center' }}>⚠️</div>
          <h1 className="page-title">This confirmation link is no longer valid</h1>
          <div className="page-intro-underline" />
          <p style={{ marginTop: '1rem', color: '#666', fontSize: '1rem', textAlign: 'center' }}>
            Your confirmation link may have expired or already been used. Enter your email below to receive a new one.
          </p>
        </div>

        <form onSubmit={handleResend} style={{ 
          background: '#fff', 
          borderRadius: 16, 
          padding: '1.5rem', 
          border: '1px solid rgba(178, 70, 70, 0.18)',
          marginTop: '2rem'
        }}>
          {(success || error) && (
            <div style={{ 
              marginBottom: 16, 
              padding: '12px', 
              background: '#fff7ed', 
              color: '#7c2d12',
              borderRadius: 8,
              fontWeight: 600,
              border: '1px solid #fed7aa'
            }}>
              If an account exists for this email, we'll send a new confirmation link.
            </div>
          )}

          <label style={{ display: 'block', fontWeight: 700, marginBottom: 6, color: '#333' }}>
            Email Address
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your.email@example.com"
            required
            style={{ 
              width: '100%', 
              padding: '12px 14px', 
              borderRadius: 10, 
              border: '1px solid rgba(0,0,0,0.15)', 
              marginBottom: 16,
              fontSize: '1rem'
            }}
          />

          <button
            type="submit"
            disabled={loading || !email.trim()}
            className={`${buttonStyles.antBtn} ${buttonStyles.antBtnPrimary}`}
            style={{ width: '100%', marginBottom: 12 }}
          >
            {loading ? 'Sending...' : 'Send new confirmation link'}
          </button>

          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Link to="/login" className={buttonStyles.textLinkBtn}>
              Back to login
            </Link>
          </div>
        </form>

        <div style={{ 
          marginTop: '2rem', 
          padding: '1rem', 
          background: '#fff7ed', 
          borderRadius: 12,
          border: '1px solid #fed7aa'
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#7c2d12' }}>
            <strong>Need help?</strong> Contact us at chowmedown321@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationError;
